import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import "../../../stylesheet/prescription.css";
import "../../../stylesheet/forms.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsCheck } from "react-icons/bs";
import { ToastContainer } from "react-toastify";
import Topnav from "../../others/Topnav";
import PatientForm from "./PatientForm";
import PatientMedicalHistory from "../PatientMedicalHistory";
import PatientAppointment from "../PatientAppointment";
import { getSelectedPatient } from "../../../Utils/localStore";
import PatientSummary from "../PatientSummary";
import ContextApi from "../../../context/ContextApi";
import WStepper from "../../utils/WizardStepper";

const NewPatient = () => {
  const [step, setStep] = useState(1);
  const [patientCreated, setPatientCreated] = useState(true);
  const [currentPatient, setCurrentPatient] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [showTextarea, setShowTextarea] = useState(false);
  const [medHistoryData, setMedHistoryData] = useState({});

  const navigate = useNavigate();

  const updateFormData = (newData) => {
    setMedHistoryData((prevData) => ({
      ...prevData,
      ...newData,
    }));
  };

  // forms states

  // patientform

  const [patientName, setPatientName] = useState("");
  const [gender, setGender] = useState("");
  const [email, setEmail] = useState("");
  const [contactDetails, setContactDetails] = useState("");
  const [address, setAddress] = useState("");
  const [age, setAge] = useState("");
  const [bloodGroup, setBloodGroup] = useState("");
  const [genoType, setGenoType] = useState("");
  const [pulse, setPulse] = useState("");
  const [weight, setWeight] = useState("");
  const [height, setHeight] = useState("");
  const [systolic, setsystolic] = useState("");
  const [diastolic, setDiastollic] = useState("");
  const [temperature, setTemperature] = useState("");
  const [sugarLevel, setSugarLevel] = useState("");
  const [insuranceProvider, setInsuranceProvider] = useState("");
  const [insuranceNumber, setInsuranceNumber] = useState("");

  // patientmedical

  const [hospitalized, setHostpitalized] = useState("");
  const [doctorcare, setIDoctorCare] = useState("");
  const [medication, setMedication] = useState("");
  const [allergies, setAllergies] = useState([]);
  const [hereditary, sethereditary] = useState([]);
  const [smoker, setSmoker] = useState(false);
  const [drinker, setDrinker] = useState("");
  const [gainedWeight, setGainedWeight] = useState("");
  const [pregnant, setPregnant] = useState("");
  const [preExistingCondition, setPreExistingCondition] = useState([]);

  // appointment

  const [responsibleDepartment, setResponsibleDepartment] = useState("");
  const [assignedPersonnel, setAssignedPersonnel] = useState("");
  const [appointmentFrequency, setAppointmentFrequency] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [sessionType, setSessionType] = useState("");

  const getLocalData = async () => {
    let response;
    try {
      await getSelectedPatient().then((resp) => (response = resp[0]));
      setCurrentPatient(response);
      const {
        patientName,
        gender,
        email,
        contactDetails,
        address,
        age,
        bloodGroup,
        genoType,
        pulse,
        weight,
        height,
        systolic,
        diastolic,
        temperature,
        sugarLevel,
        insuranceProvider,
        insuranceNumber,
        hospitalized,
        doctorcare,
        medication,
        allergies,
        hereditary,
        smoker,
        drinker,
        preExistingCondition,
        responsibleDepartment,
        assignedPersonnel,
        appointmentFrequency,
        startDate,
        endDate,
        startTime,
        endTime,
        sessionType,
      } = response;
      setPatientName(patientName);
      setGender(gender);
      setEmail(email);
      setContactDetails(contactDetails);
      setAddress(address);
      setAge(age);
      setBloodGroup(bloodGroup);
      setGenoType(genoType);
      setPulse(pulse);
      setWeight(weight);
      setHeight(height);
      setsystolic(systolic);
      setDiastollic(diastolic);
      setTemperature(temperature);
      setSugarLevel(sugarLevel);
      setInsuranceProvider(insuranceProvider);
      setInsuranceNumber(insuranceNumber);
      setHostpitalized(hospitalized);
      setIDoctorCare(doctorcare);
      setMedication(medication);
      setAllergies(allergies);
      sethereditary(hereditary);
      setSmoker(smoker);
      setDrinker(drinker);
      setGainedWeight(gainedWeight);
      setPregnant(pregnant);
      setPreExistingCondition(preExistingCondition);
      setResponsibleDepartment(responsibleDepartment);
      setAssignedPersonnel(assignedPersonnel);
      setAppointmentFrequency(appointmentFrequency);
      setStartDate(startDate);
      setEndDate(endDate);
      setStartTime(startTime);
      setEndTime(endTime);
      setSessionType(sessionType);
    } catch (error) {
      // notify.error(error, { position: notify.POSITION.TOP_CENTER })
      throw new Error(error);
    }
  };
  useEffect(() => {
    if (localStorage.getItem("patientEditMode") === "true") {
      setEditMode(true);
      getLocalData();
    }
    const fastPosition = window.location.search.includes("summary")
      ? "summary"
      : "";
    if (fastPosition) {
      setStep(4);
    }
    return;
  }, [setEditMode, setStep]);

  const handleContinue = (data) => {
    setStep((prevStep) => prevStep + 1);
  };

  const handleBack = () => {
    setStep((prevStep) => prevStep - 1);
  };

  const handleSubmit = () => {
    if (localStorage.getItem("patientEditMode") === "true") {
      toast.success("Patient Updated Successfully!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } else {
      toast.success("Patient added successfully!", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
    navigate("/patients");
  };

  const handleShowTextarea = (event) => {
    setShowTextarea(event.target.value === "Yes");
  };

  return (
    <div className="new">
      <Topnav />
      <ContextApi.Provider
        value={{
          patientName,
          setPatientName,
          gender,
          setGender,
          email,
          setEmail,
          contactDetails,
          setContactDetails,
          address,
          setAddress,
          age,
          setAge,
          bloodGroup,
          setBloodGroup,
          genoType,
          setGenoType,
          pulse,
          setPulse,
          weight,
          setWeight,
          height,
          setHeight,
          systolic,
          setsystolic,
          diastolic,
          setDiastollic,
          temperature,
          setTemperature,
          sugarLevel,
          setSugarLevel,
          insuranceProvider,
          setInsuranceProvider,
          insuranceNumber,
          setInsuranceNumber,
          hospitalized,
          setHostpitalized,
          doctorcare,
          setIDoctorCare,
          medication,
          setMedication,
          allergies,
          setAllergies,
          hereditary,
          sethereditary,
          smoker,
          setSmoker,
          drinker,
          setDrinker,
          gainedWeight,
          setGainedWeight,
          pregnant,
          setPregnant,
          preExistingCondition,
          setPreExistingCondition,
          responsibleDepartment,
          setResponsibleDepartment,
          assignedPersonnel,
          setAssignedPersonnel,
          appointmentFrequency,
          setAppointmentFrequency,
          startDate,
          setStartDate,
          endDate,
          setEndDate,
          startTime,
          setStartTime,
          endTime,
          setEndTime,
          sessionType,
          setSessionType,
        }}
      >
        {/* form-container w-90 px-8 */}
        <div className="overflow-hidden">
          <div className="w-full flex justify-center my-6 px-4">
            <WStepper
              currentTab={step}
              config={[
                {
                  name: "patient details",
                  status: "",
                },
                {
                  name: "medical history",
                  status: "",
                },
                {
                  name: "appointment & delegation",
                  status: "",
                },
                {
                  name: "Summary",
                  status: "Completed",
                },
              ]}
            />
          </div>

          <div className="w-full lg:flex justify-center p-4">
            <section className="">
              {step === 1 && <PatientForm onContinue={handleContinue} />}
              {step === 2 && (
                <PatientMedicalHistory
                  props={[medHistoryData, setMedHistoryData]}
                  onChange={handleShowTextarea}
                  onContinue={handleContinue}
                  onBack={handleBack}
                />
              )}
              {step === 3 && (
                <PatientAppointment
                  onContinue={handleContinue}
                  onSubmit={handleSubmit}
                  onBack={handleBack}
                />
              )}
              {step === 4 && (
                <PatientSummary onBack={handleBack} onSubmit={handleSubmit} />
              )}
            </section>
          </div>
        </div>
        <ToastContainer />
      </ContextApi.Provider>
    </div>
  );
};

export default NewPatient;
